export { default } from './onboarding-requirements';
